<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <!--<InfoOrder :orderType="orderType"></InfoOrder>
       <br>
       <SumOrders ref="SumOrders"></SumOrders>-->

    <div id="data-list-thumb-view" class="data-list-container">
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Contrato</h6>
              <v-select
                name="customer"
                v-model="contractCustomerSelected"
                :options="contracts"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-validate="'required'"
              />
              <br />
              <span class="text-danger">{{ errors.first("customer") }}</span>
            </div>
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Produto</h6>
              <v-select :options="getProducts" label="label" v-model="product">
                <template slot="option" slot-scope="option">
                  <img
                    :src="option.image"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"
                  />
                  {{ option.label }}
                </template>
              </v-select>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Finalidade</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    color="primary"
                    v-model="finality"
                    vs-value="Locação"
                    >Locação</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    color="success"
                    v-model="finality"
                    vs-value="Revenda"
                    >Revenda</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
             <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Proprietário</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    color="primary"
                    v-model="owner"
                    vs-value="Copyjui"
                    >Copyjui</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    color="success"
                    v-model="owner"
                    vs-value="Prime"
                    >Prime</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Número de Série</h6>
              <vs-input v-model="serialNumber" class="w-full" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5" v-if="product">
              <h6 class="mb-2">Fornecedor</h6>
              <vs-input v-model="product.trademark" class="w-full" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Valor da Compra</h6>
              <vs-input
                class="w-full"
                v-model="price"
                v-currency="{ currency: 'BRL', locale: 'pt-br' }"
              />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">NF de Entrada</h6>
              <vs-input class="w-full" v-model="nf" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Data de Entrada</h6>
              <datepicker
                      placeholder="Selecione a Data"
                      :language="languages['ptBR']"
                      format="dd/MM/yyyy"
                      v-model="entryDate"
                    ></datepicker>   
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Local</h6>
              <vs-input class="w-full" v-model="sector" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Patrimônio</h6>
              <vs-input class="w-full" v-model="patrimony" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">NF de Saída</h6>
              <vs-input class="w-full" v-model="outgoingInvoice" />
            </div>
            <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Data de Saída</h6>
              <datepicker
                      placeholder="Selecione a Data"
                      :language="languages['ptBR']"
                      format="dd/MM/yyyy"
                      v-model="exitDate"
                    ></datepicker>   
            </div>
             <div class="vx-col md:w-1/3 w-1/3 mt-5">
              <h6 class="mb-2">Valor da Venda</h6>
              <vs-input
                class="w-full"
                v-model="saleValue"
                v-currency="{ currency: 'BRL', locale: 'pt-br' }"
              />
            </div>
           
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mt-5">
              <vs-button
                class="float-right"
                color="success"
                v-show="product"
                @click="add"
                >Adicionar</vs-button
              >
            </div>
          </div>
        </div>
      </vx-card>
      <br />
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPageConfirmed"
        search
        :data="productsSelected"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="flex flex-wrap-reverse items-center"></div>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * itemsPerPageConfirmed -
                  (itemsPerPageConfirmed - 1)
                }}
                -
                {{
                  productsSelected.length -
                    currentPage * itemsPerPageConfirmed >
                  0
                    ? currentPage * itemsPerPageConfirmed
                    : productsSelected.length
                }}
                of {{ queriedItemsConfirmed }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPageConfirmed = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPageConfirmed = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Produto</vs-th>
          <vs-th sort-key="code">Código</vs-th>
          <vs-th>Série</vs-th>
          <vs-th>Fornecedor</vs-th>
          <vs-th>Preço</vs-th>
          <vs-th>Finalidade</vs-th>
          <vs-th>Local</vs-th>
          <vs-th>Patrimônio</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr
              :data="product"
              :key="indextr"
              v-for="(product, indextr) in data"
            >
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.name }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.code }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.serialNumber }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.trademark }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.price }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.finality }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.sector }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.patrimony }}
                </p>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(product.idProduct)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <vs-button
              v-show="productsSelected.length > 0"
              class="float-right"
              color="success"
              @click="submit"
              >Salvar</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { momentJS, numberJS } from "@/helpers";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { baseApiUrl } from "@/global";
import router from "@/router";
import axios from "axios";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: { vSelect, Datepicker },
  props: {},
  data() {
    return {
      contracts: [],
      languages: lang,
      contractCustomerSelected: [],
      product: null,
      name: null,
      price: null,
      nf: null,
      entryDate: null,
      outgoingInvoice: null,
      serialNumber: null,
      finality: "Locação",
      owner: "Copyjui",
      sector: "",
      patrimony: "",
      exitDate : null,
      saleValue : null,
      productsSelected: [],
      confirmedProducts: [],
      itemsPerPageConfirmed: 10,
      itemsPerPage: 30,
      isMounted: false,
    };
  },
  computed: {
    getUsers() {
      return this.$store.state.usersFiltered;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItemsConfirmed() {
      return this.$refs.tableConfirmed
        ? this.$refs.tableConfirmed.queriedResults.length
        : this.productsSelected.length;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.getProducts.length;
    },
    getProducts() {
      let products = _.cloneDeep(this.$store.state.products);
      products.forEach((element) => {
        element.id = element.idProduct;
        element.label = `${element.name} | ${element.code}`;
        element.image = element.photoProduct;
      });
      return products;
    },
  },
  methods: {
    async loadPermanentContracts() {
      try {
        this.$vs.loading();
        const response = await axios.get(
          `${baseApiUrl}/permanentAsset/getContractsPermanentAsset`
        );
        this.$vs.loading.close();
        this.contracts = response.data;
        this.contracts.forEach((element) => {
          element.id = element.idContractPermanentAsset;
          element.label = `${element.idContractPermanentAsset} | ${element.corporateName}`;
        });
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    add() {
      try {
        let item = {
          fk_idProduct: this.product.idProduct,
          serialNumber: this.serialNumber,
          name: this.product.name,
          code: this.product.code,
          price: this.price,
          trademark: this.product.trademark,
          finality: this.finality,
          owner : this.owner,
          sector: this.sector,
          patrimony: this.patrimony,
          nf: this.nf,
          entryDate: this.entryDate,
          outgoingInvoice: this.outgoingInvoice,
          saleValue: this.saleValue,
          exitDate: this.exitDate,
          createAt: momentJS().getDateTime(),
        };
        this.productsSelected.push(item);
        this.clear();
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Adicionado",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Adicionar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    clear() {
      this.name = "";
      this.price = "";
      (this.nf = ""), (this.product = "");
      this.trademark = "";
      this.serialNumber = ""; 
      this.sector = "";
      this.patrimony = "";
      this.outgoingInvoice ="";
      //  this.finality= "Locação";
    },
    async submit() {
      try {
        let data = {
          fk_idContractPermanentAsset: this.contractCustomerSelected.id,
          createAt: momentJS().getDateTime(),
          fk_idUser: this.$store.state.user.idUser,
          items: this.productsSelected,
        }; 
        const response = await axios.post(
          `${baseApiUrl}/permanentAsset/saveAsset`,
          data
        );

        this.clear();
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (response.status == "200") {
          router.push("/ativos").catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Salvar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    /* 
    <v-select :options="getProducts" label="label" v-model="product" @input="updateTrademark(product.trademark)">
    updateTrademark(value) {
      this.trademark = value;
    },*/
    deleteData(idProduct) {
      const productIndex = this.productsSelected.findIndex(
        (p) => p.idProduct == idProduct
      );
      this.productsSelected.splice(productIndex, 1);
    },
  },
  async created() {
    this.entryDate = momentJS().getDateTime();
    //this.exitDate = momentJS().getDateTime();
    let payload = {
      loading: this.$vs.loading,
    };
    await this.loadPermanentContracts();
    this.$store.dispatch("fetchProductsItems", payload);
    this.$store.dispatch("fetchAllUsers", payload);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>